import { Button } from 'semantic-ui-react';
import { eventDisplayName, objectToString } from 'src/components/helpers';

export const PendingEventGuestsRowDef = (onAssignClick) => [
  {
    headerName: 'Nombre',
    field: 'fullName',
    valueGetter: (params) =>
      `${params.data?.Guest?.name || ''} ${params.data?.Guest?.lastName || ''}`.trim(),
    flex: 2,
    minWidth: 180,
  },
  {
    headerName: 'Cédula',
    field: 'identification',
    valueGetter: (params) => params.data?.Guest?.identification,
    flex: 1,
    minWidth: 120,
  },
  {
    headerName: 'Evento',
    field: 'eventSlugname',
    valueGetter: (params) => eventDisplayName(params.data?.eventSlugname),
    flex: 2,
    minWidth: 160,
  },
  {
    headerName: 'Pago',
    field: 'payment',
    valueGetter: (params) => params.data?.payment?.amount || '-',
    flex: 1,
    minWidth: 100,
  },
  {
    headerName: 'Info extra',
    field: 'aditionalinformation',
    valueGetter: (params) => {
      const info = params.data?.aditionalinformation;
      return Object.keys(info || {}).length ? objectToString(info) : '-';
    },
    cellRenderer: (params) => {
      const info = params.data?.aditionalinformation;
      if (!Object.keys(info || {}).length) return '-';
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: objectToString(info),
          }}
        />
      );
    },
    flex: 2,
    minWidth: 180,
    autoHeight: true,
  },
  {
    headerName: 'Acciones',
    field: 'actions',
    sortable: false,
    filter: false,
    width: 140,
    cellRenderer: (params) => (
      <Button size="tiny" primary onClick={() => onAssignClick(params.data)}>
        Asignar
      </Button>
    ),
  },
];
